var _defs, _path, _circle, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartsen1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gaugeGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#22D3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FACC15"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 72a40 40 0 1 1 80 0",
    fill: "none",
    stroke: "url(#gaugeGrad)",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 72,
    r: 6,
    fill: "#1F2937"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 72,
    x2: 88,
    y2: 56,
    stroke: "#1F2937",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartsen1);
export default __webpack_public_path__ + "static/media/smartsen_1.ec53597ce6d6de71202d3d598e3ab8c7.svg";
export { ForwardRef as ReactComponent };